import { Header } from 'components/slider/header';

import { ICasino, IUser } from 'constants/types';

import styles from './styles.module.css';
import { ReviewsMasonry } from 'components/reviews-masonry';
import { ReviewSlot } from 'components/cards/slot';

export const TableReviewSlot = ({
  user,
  id,
  anchor,
  variant,
  casinos,
}: {
  user?: IUser;
  id: string | string[] | undefined;
  anchor?: string;
  variant: 'slot' | 'user';
  casinos: ICasino[] | undefined;
}) => {
  if (!user?.slots_reviews?.length) {
    return null;
  }
  return (
    <section className={styles.reviews}>
      <div className={styles.container_s} id={anchor}>
        <Header
          hasIcon={false}
          name={id ? 'Slots RTP checks' : 'My slots RTP checks'}
          count={user?.slots_reviews?.length?.toString()}
          isSmallName
        />
        <ReviewsMasonry gap="10px">
          {user?.slots_reviews?.map((item) => (
            <ReviewSlot
              slot={user?.slots_reviews_info?.find(
                (slot) => slot._id === item.slot_id
              )}
              casino={casinos?.find((casino) => casino._id === item.casino_id)}
              key={item._id.toString()}
              data={item}
              isPublicProfile={!!id}
              variant={variant}
            />
          ))}
        </ReviewsMasonry>
      </div>
    </section>
  );
};
